import {RESERVATION_CONFIRMED_BUTTON_LABEL, RESERVATION_RESEND_LINK_TEXT} from "../../reservation/constants/reservation_copy";
import type {IReservationTrackingContext} from "../../reservation/tracking/track_reservation_events";
import {IReservationRequest} from "../../reservation/types/IReservationRequest";
import {UnlockChoiceEntryPoint} from "../types/UnlockChoiceEntryPoint";
import {getAmplitudeFlowTracking} from "../utils/get_amplitude_flow_tracking";
import {getAmplitudeAuthLocation} from "./track_amplitude_auth_event";
import {trackUnlockChoiceModalView, trackUnlockChoiceReservationButtonClick, UnlockChoiceTrackingContext} from "./track_unlock_choice_events";

/*
 * The reservation started from the unlock choice modal continues the funnel of its choice, so its steps are reported as the choice is.
 * It is reported with step views and button clicks only - no lead form events and no GTM events.
 */

// the reservation card is offered by the offer choice only, whose entry points share one tracking config
const getChoiceTrackingContext = (request: IReservationRequest, context: IReservationTrackingContext): UnlockChoiceTrackingContext => ({
    entryPoint: UnlockChoiceEntryPoint.PRICE,
    authPlacement: context.authPlacement ?? null,
    location: getAmplitudeFlowTracking({amplitudeLocation: context.amplitudeLocation}, getAmplitudeAuthLocation(context.viewType ?? null)).location,
    itemId: request.offerId,
    propertyId: request.propertyId
});

// Once per showing of the code entry - typing, a resend or a rejected code do not report it again
export const trackUnlockChoiceReservationCodeView = (request: IReservationRequest, context: IReservationTrackingContext = {}) => {
    trackUnlockChoiceModalView(getChoiceTrackingContext(request, context), "rp_reservation_code");
};

export const trackUnlockChoiceReservationConfirmedView = (request: IReservationRequest, context: IReservationTrackingContext = {}) => {
    trackUnlockChoiceModalView(getChoiceTrackingContext(request, context), "rp_reservation_confirmed");
};

export const trackUnlockChoiceReservationResend = (request: IReservationRequest, context: IReservationTrackingContext = {}) => {
    trackUnlockChoiceReservationButtonClick(getChoiceTrackingContext(request, context), "rp_reservation_resend", RESERVATION_RESEND_LINK_TEXT);
};

export const trackUnlockChoiceReservationBack = (request: IReservationRequest, context: IReservationTrackingContext = {}) => {
    trackUnlockChoiceReservationButtonClick(getChoiceTrackingContext(request, context), "rp_reservation_back");
};

// The close button of the code step - the confirmation closed with the overlay or Esc is not reported
export const trackUnlockChoiceReservationClose = (request: IReservationRequest, context: IReservationTrackingContext = {}) => {
    trackUnlockChoiceReservationButtonClick(getChoiceTrackingContext(request, context), "rp_reservation_close");
};

// ROZUMIEM of the confirmation - the last step of the funnel
export const trackUnlockChoiceReservationAck = (request: IReservationRequest, context: IReservationTrackingContext = {}) => {
    trackUnlockChoiceReservationButtonClick(getChoiceTrackingContext(request, context), "rp_reservation_ack", RESERVATION_CONFIRMED_BUTTON_LABEL);
};
import {RESERVATION_CONFIRMED_BUTTON_LABEL, RESERVATION_RESEND_LINK_TEXT} from "../../reservation/constants/reservation_copy";
import type {IReservationTrackingContext} from "../../reservation/tracking/track_reservation_events";
import {IReservationRequest} from "../../reservation/types/IReservationRequest";
import {UnlockChoiceEntryPoint} from "../types/UnlockChoiceEntryPoint";
import {getAmplitudeFlowTracking} from "../utils/get_amplitude_flow_tracking";
import {getAmplitudeAuthLocation} from "./track_amplitude_auth_event";
import {trackUnlockChoiceModalView, trackUnlockChoiceReservationButtonClick, UnlockChoiceTrackingContext} from "./track_unlock_choice_events";

/*
 * The reservation started from the unlock choice modal continues the funnel of its choice, so its steps are reported as the choice is.
 * It is reported with step views and button clicks only - no lead form events and no GTM events.
 */

// the reservation card is offered by the offer choice only, whose entry points share one tracking config
const getChoiceTrackingContext = (request: IReservationRequest, context: IReservationTrackingContext): UnlockChoiceTrackingContext => ({
    entryPoint: UnlockChoiceEntryPoint.PRICE,
    authPlacement: context.authPlacement ?? null,
    location: getAmplitudeFlowTracking({amplitudeLocation: context.amplitudeLocation}, getAmplitudeAuthLocation(context.viewType ?? null)).location,
    itemId: request.offerId,
    propertyId: request.propertyId
});

// Once per showing of the code entry - typing, a resend or a rejected code do not report it again
export const trackUnlockChoiceReservationCodeView = (request: IReservationRequest, context: IReservationTrackingContext = {}) => {
    trackUnlockChoiceModalView(getChoiceTrackingContext(request, context), "rp_reservation_code");
};

export const trackUnlockChoiceReservationConfirmedView = (request: IReservationRequest, context: IReservationTrackingContext = {}) => {
    trackUnlockChoiceModalView(getChoiceTrackingContext(request, context), "rp_reservation_confirmed");
};

export const trackUnlockChoiceReservationResend = (request: IReservationRequest, context: IReservationTrackingContext = {}) => {
    trackUnlockChoiceReservationButtonClick(getChoiceTrackingContext(request, context), "rp_reservation_resend", RESERVATION_RESEND_LINK_TEXT);
};

export const trackUnlockChoiceReservationBack = (request: IReservationRequest, context: IReservationTrackingContext = {}) => {
    trackUnlockChoiceReservationButtonClick(getChoiceTrackingContext(request, context), "rp_reservation_back");
};

// The close button of the code step - the confirmation closed with the overlay or Esc is not reported
export const trackUnlockChoiceReservationClose = (request: IReservationRequest, context: IReservationTrackingContext = {}) => {
    trackUnlockChoiceReservationButtonClick(getChoiceTrackingContext(request, context), "rp_reservation_close");
};

// ROZUMIEM of the confirmation - the last step of the funnel
export const trackUnlockChoiceReservationAck = (request: IReservationRequest, context: IReservationTrackingContext = {}) => {
    trackUnlockChoiceReservationButtonClick(getChoiceTrackingContext(request, context), "rp_reservation_ack", RESERVATION_CONFIRMED_BUTTON_LABEL);
};
